import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './ForgotPassword.css';
import Button from '../../components/Button';
import Logo from '../../components/Logo';
import { forgotPhoneFields, forgotEmailFields } from '../../forms/member/forgot';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';
import adminActions from '../../actions/admin';
import formHelpers from '../../helpers/FormHelpers';



class ForgotPassword extends Component {
  constructor() {
    super();
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleRetrieveClick = this.handleRetrieveClick.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.changeRetrieveMethod = this.changeRetrieveMethod.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);
  }

  componentWillMount() {
    this.setState({
      fields: forgotEmailFields,
      method: 'email',
      methodText: 'Retrieve By Text Message?'
    })
  }

  changeRetrieveMethod() {
    if (this.state.method === 'phone') {
      this.setState({
        fields: forgotEmailFields,
        method: 'email',
        methodText: 'Retrieve By Text Message?'
      })
    } else {
      this.setState({
        fields: forgotPhoneFields,
        method: 'phone',
        methodText: 'Retrieve By Email?'
      })
    }
  }

  handleFieldBlur(name) {
    formHelpers.handleFieldBlur(name, 'fields', this);
  }

  handleFieldChange(value, name) {
    formHelpers.handleFieldChange(value, name, 'fields', this);
  }

  handleFieldFocus(name) {
    formHelpers.handleFieldFocus(name, this.state.currentPhase, this);
  }

  handleRetrieveClick() {
    const { fields } = this.state;
    let data = extractPhasesOrFail({ fields });
    if (data) {
      this.props.dispatch(adminActions.forgot(data), this.props.router);
    } else {
      this.setState({
        fields: this.blurphase(fields)
      })
    }
  }

  render() {
    const { fields } = this.state;
    return (
      <div className="saga-wrap">
        <div className="saga">
          <div className="forgot__form">
            <Logo />
            <h1 className="forgot__title">Password Recovery</h1>
            { formHelpers.buildFields(fields, this) }
            <div className="clear"></div>
						<Link to="/" className="signin__forgot simple-link">
              Sign in
						</Link>
            <div className="clear"></div>
            <Button
              text="Retrieve Password"
              allowHover={true}
              center={true}
              onClick={this.handleRetrieveClick}/>
            <div className="clear"></div>
{
//     Commented out till API supports phone --EE
//            <Button
//              text="Not a member yet? Sign Up"
//              unwrap={true}
//              center={true}
//              whereTo="/sign-up"/>

//            <Button
//              text={this.state.methodText}
//              unwrap={true}
//              center={true}
//              onClick={this.changeRetrieveMethod}/>
            }
            <div className="clear"></div>
          </div>
          <div className="clear"></div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({})
)(ForgotPassword);



/** WEBPACK FOOTER **
 ** ./src/containers/ForgotPassword/index.js
 **/